<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput type="text" label="Nombre" name="name" id="name" rules="required" v-model="producto.name" />
            </b-col>
            <b-col cols="12" class="mt-2">
                <FormInput type="text" label="Descripción" name="description" id="description" rules="required" v-model="producto.description" />
            </b-col>
            <b-col cols="12" class="mt-2 mb-2">
                <label for="categorias">Categoría</label>
                <multiselect
                    v-model="producto.categoria"
                    placeholder="Categorías"
                    track-by="id"
                    label="name"
                    :options="categorias"
                    @input="manejarError"
                />
                <span v-if="errorCategoria" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>El campo categoría es obligatorio</b></span>
            </b-col>
            <b-col cols="12" class="mt-2">
                <label for="imagen">Imagen</label>
                <p>
                    <small>
                        MEDIDAS: 800x600 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>

                <Dropzone 
                    v-if="url && !producto.imagen"
                    :url="url"
                    :height="600"
                    :width="800"
                    @processing="(file) => { subiendoImagen = true; }"
                    :acceptedFiles="'image/jpeg'"
                    @success="imagenSubida"
                    :resizeHeight=730
                    :resizeWidth=860
                />
                <template v-else>
                    <img 
                        :src="producto.imagen" 
                        alt="Imagen subida" 
                        style="
                            max-height: 200px; 
                            border: 2px solid rgba(0, 0, 0, 0.2); 
                            border-radius: 8px; 
                        "
                    />
                    <br/>
                    <Button class="mt-3" @click="borrarImagen">Borrar</Button>
                </template>
            </b-col>

            <b-col v-if="error && !producto.imagen_url" cols="12" class="mt-2">
                <div class="alert alert-danger">
                    <b>{{ error }}</b>
                </div>
            </b-col>

            <b-col cols="12" class="text-right mt-3">
                <Button type="submit" name="button" :disabled="subiendoImagen">
                    CONTINUAR
                </Button>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['producto', 'error'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                categorias: [],
                subiendoImagen: false,
                errorCategoria: false
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if(isValid && !this.subiendoImagen && !this.errorCategoria) {
                    this.producto.teatro_id = this.teatro.id;
                    this.terminar();
                }
            },
            getCategorias() {
                const params = {
                    filters: {
                        to_select: true
                    },
                    teatro_id: this.teatro.id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.index'), params)
                    .then(res => {
                        this.categorias = res.data.data;
                    })
                    .catch(error => {
                        this.$toast.error(error.response.data.message);
                    });
            },
            imagenSubida(file, response) {
                this.producto.subir_imagen = response;
                this.subiendoImagen = false;
            },
            borrarImagen() {
                this.producto.imagen = null;
                this.$emit('imagenBorrada');
            },
            terminar() {
                this.$emit('terminado');
            },
            manejarError() {
                if (this.producto.categoria) {
                    this.errorCategoria = false;
                } else {
                    this.errorCategoria = true;
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getCategorias();
        },
        components: {
            Dropzone
        }
    }
</script>
